export const reloadDataType = {
    // CLIENT
    client: 'client',
    // HOSPITAL
    hospital: 'hospital',
    // USER
    user: 'user',
    userPathway: 'userPathway',
    userStaticList: 'userStaticList',
    userSupportTeam: 'userSupportTeam',
    // USER WITH ROLE
    hcp: 'hcp',
    hcpRole: 'hcpRole',
    userManagement: 'userManagement',
    // GP
    gp: 'gp',
    // PATHWAY
    pathway: 'pathway',
    // SUPPORT TEAM
    supportTeam: 'supportTeam',
    // STATIC LIST
    staticList: 'staticList',
    // NOTIFICATIONS
    notification: 'notification',
    // CALENDAR ITEM
    calendarItem: 'calendarItem',
    // TIMEZONE
    timezone: 'timezone',
    // APP CONFIG
    appConfiguration: 'appConfiguration',
    // SYSTEM CONFIG
    systemConfiguration: 'systemConfiguration',
    // GENERIC LOG
    genericLog: 'genericLog',
}
